import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './home/login.component';
import { RequestResetPasswordComponent } from './home/request-reset-password.component';
import { ResetPasswordComponent } from './home/reset-password.component';
import { PermissionGuard } from '../services/permission-guard.service';
import { OtpVerificationComponent } from './home/otp-verification.component';
import { SmsVerificationInfoComponent } from './home/sms-verification-info.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'orders' },
  { path: 'login', component: LoginComponent },
  { path: 'resetPassword', component: RequestResetPasswordComponent },
  { path: 'verify-otp', component: OtpVerificationComponent },
  { path: 'reset/:identifier', component: ResetPasswordComponent },
  { path: '2fa-sms-verification', component: SmsVerificationInfoComponent },
  { path: 'admin',canActivate:[PermissionGuard], loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },

  { path: 'search', loadChildren: () => import('./search/search.module').then(m => m.SearchModule) },
  { path: 'users', canActivate:[PermissionGuard], loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
  { path: 'locations', canActivate:[PermissionGuard], loadChildren: () => import('./locations/locations.module').then(m => m.LocationsModule) },
  { path: 'invoices', canActivate:[PermissionGuard], loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule) },
  { path: 'orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule) },
  // { path: 'quotes', loadChildren: () => import('./quotes/quotes.module').then(m => m.QuotesModule) },
  { path: 'tenders', canActivate:[PermissionGuard], loadChildren: () => import('./tender/tender.module').then(m => m.TenderModule) },
  { path: 'reporting', canActivate:[PermissionGuard], loadChildren: ()=> import('./reporting/reporting.module').then(m => m.ReportingModule) },
  {
    path: '**',
    redirectTo: 'orders',
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutesModule { }
